<template>
  <vs-row class="mb-4">
    <vs-col class="w-full">
      <vs-alert :active="show" :icon="period.updated ? 'check' : 'new_releases'" :color="period.updated ? 'success' : 'danger'">
        <div v-show="period.updated">
           <span class="text-sentence">{{`${$t('period')} ${$t('month')}: ${period.Month} ${$t('week')}: ${period.MonthWeek}`}} {{`(${formatDate(period.BeginDate)} - ${formatDate(period.EndDate)})`}}, {{$t('exchange_rate')}}: 
          <span>{{ formatNumber(period.ExchangeRate, 4) }}</span>.
          </span>
        </div>
        <div v-show="!period.updated">
           <span class="text-sentence">{{`${$t('period')} ${$t('month')}: ${period.Month} ${$t('week')}: ${period.MonthWeek}`}} {{`(${formatDate(period.BeginDate)} - ${formatDate(period.EndDate)})`}}, {{$t('exchange_rate')}}: 
          <span>{{ formatNumber(period.ExchangeRate, 4) }}</span>.
          
          <update-exchange-rate
            :popupTitle="$t('update_exchange_rate')"
            :period="period"
            btnType="line"
            btnIcon="cached"
            :btnText="$t('click_here_to_update')"
            class="inline exchange"
            :min="min"
            v-if="allowEditing"
          />
          </span>
        </div>
      </vs-alert>
    </vs-col>
  </vs-row>
</template>

<script>
import UpdateExchangeRate from '@/views/apps/invoices/components/UpdateExchangeRate.vue'
export default {
  components: {
    UpdateExchangeRate
  },
  data() {
    return {
      show: false,
      allowEditing:false,
      min:4
    }
  },
  computed: {
    period() {
      return this.$store.state.invoice.period
    }
  },
  mounted() {
    this.allowEditing = this.hasPermission(['IU CONTRALOR EDIT'])
    this.$store.dispatch('invoice/getCurrentPeriod').then(res => {
      this.show = true
    })
  }
}
</script>

<style lang="css" scoped>
.exchange {
  font-weight: bold;
  font-style: italic;
  text-decoration: underline;
}
.inline {
  display: inline-flex;
}
</style>
